import React from 'react';
import PropTypes from 'prop-types';
import Highlighter from "react-highlight-words";

class SearchItem extends React.Component {

    constructor(props) {
        super(props);
    }

    unescapeHtml(escapedHtml) {
        let doc = new DOMParser().parseFromString(escapedHtml, 'text/html');
        return doc.documentElement.textContent;
    }

    render() {
    
    let iref_article = this.props.sort === '1' ? '?iref=pc_ss_score_article' : '?iref=pc_ss_date_article';

    let year = this.props.ReleaseDate.substr(0,4);
    let month = this.props.ReleaseDate.substr(4,2);
    let day = this.props.ReleaseDate.substr(6,2);
    let date = year + '/' + month + '/' + day;

    let li_class_list = {
        PR: {
            img: '//www.asahicom.jp/search/css/images/result/cat_and_m_pr.png',
            alt: '＆Ｍ・企業リリース'
        },
        webronza: {
            img: '//www.asahicom.jp/search/css/images/result/cat_webronza.png',
            alt: 'WEBRONZA'
        },
        and_m: {
            img: '//www.asahicom.jp/search/css/images/result/cat_and_m.png',
            alt: '＆Ｍ'
        },
        and_w: {
            img: '//www.asahicom.jp/search/css/images/result/cat_and_w.png',
            alt: '＆Ｗ'
        },
        shimbun: {
            img: '//www.asahicom.jp/search/css/images/result/cat_shimbun.png',
            alt: '紙面掲載記事'
        },
        book: {
            img: '//www.asahicom.jp/search/css/images/result/cat_kosho_koujitu.png',
            alt: 'BOOK'
        },
        EduA: {
            img: '//www.asahicom.jp/search/css/images/result/cat_EduA.png',
            alt: 'EduA'
        }
    }

    let CategoryIcon;
    if(li_class_list[this.props.li_class]){
        let img = li_class_list[this.props.li_class]['img'];
        let alt = li_class_list[this.props.li_class]['alt'];
        CategoryIcon = <span className='CategoryIcon'><img src={img} alt={alt} /></span>;
    } else {
        CategoryIcon = null;
    }

    let Image;
    if (this.props.PHOTOURL !== null){
        let re = /(.*\/AS.*?_comm)(\.jpg)$/;
        let image = this.props.PHOTOURL.replace(re, '$1L$2');
        Image = <span className="Image"><img src={image} width="120" alt="写真・図版" /></span>
    } else {
        Image = null
    }

    let key_type_list = {
        GOLD: {
            class: 'KeyGold',
            img: '//www.asahicom.jp/images/icon_key_gold.gif',
            alt: '有料会員記事'
        },
        SILVER: {
            class: 'KeySilver',
            img: '//www.asahicom.jp/images/icon_key_silver.gif',
            alt: '会員記事'
        }
    }
    
    let KeyIcon;
    KeyIcon = null;

    // 見出し対応
    let Midashi;
    Midashi = this.props.TITLE;

    // 本文対応
    let Honbun;
    Honbun = this.unescapeHtml(this.props.BODY);

    // 本文がnullである場合は、本文を非表示
    if (Honbun == "null"){
      Honbun = "";
    }

    // ニュースの要点判別で表示を出しわけ　// 〈ニュースの要点〉
    if ( Honbun.includes('〈ニュースの要点〉') ) {
      Midashi = "［" + Number(month)  + "月" + Number(day) + "日 ニュースの要点］" + Midashi;
      Honbun = "いま注目の主要ニュース３本を厳選。「ここがＰＯＩＮＴ」に目を通せば、１分で大事なポイントや背景がわかります。平日朝に配信します。" ;
    }

    return (
        <li className={this.props.li_class}>
        <a href={this.props.URL + iref_article}>
            {CategoryIcon}
            {Image}
            <span className="SearchResult_Headline">
                <em><Highlighter highlightStyle={{ backgroundColor: '#ffeb00' }}　searchWords={this.props.highlightwords} textToHighlight={Midashi}/></em>
                <span className="Date">({date}){KeyIcon}</span>
            </span>
            <span className="read">
                <Highlighter highlightStyle={{ backgroundColor: '#ffeb00' }} searchWords={this.props.highlightwords} textToHighlight={Honbun}/>
            </span>
        </a>
        </li>
    );
    }
}

SearchItem.propTypes = {
    post: PropTypes.shape({
        sort: PropTypes.string.isRequired,
        BODY: PropTypes.string.isRequired,
        PHOTOURL: PropTypes.string.isRequired,
        ReleaseDate: PropTypes.string.isRequired,
        TITLE: PropTypes.string.isRequired,
        URL: PropTypes.string.isRequired,
        key_type: PropTypes.string.isRequired,
        li_class: PropTypes.string.isRequired,
        highlightwords: PropTypes.string.isRequired
    })
}

export default SearchItem;
